import React, { memo } from 'react';
import { componentService } from 'js/services/component.service';

import * as Types from './types';
import { CheckboxBare } from '../Checkbox';
import { withFinalFormField } from '../../hocs';

export const ToggleBare: React.FC<Types.IToggleProps> = (props) => {
    return <CheckboxBare {...props} isToggle />;
};

export const TogglePure = memo(ToggleBare);
export const Toggle = withFinalFormField<string>({ type: 'checkbox' })(TogglePure);

componentService.registerWebContentComponents({ Toggle: TogglePure });
